<template>
    <div class="stretch-layout">
        <card xs-tile sm-tile class="flex-grow-1">
            <iframe :src="source" id="stay22-widget" width="100%" height="100%" frameborder="0" class="flex-grow-1"></iframe>
        </card>
    </div>
</template>

<script setup lang="ts">
import {useEventStore} from "../../../store/event";

const eventStore = useEventStore();
const {t} = useI18n();
const {$image, $date} = useNuxtApp();

const {data} = await useApiFetch(`/v1/view/events/${eventStore.event.id}/stay`, {
	guest: true,
	params: {
		ts: eventStore.event.map_cache_buster,
	}
})

const source = computed(() => {
	const color = eventStore.colorStyle.split('#')[1];
	const params = {
		aid: 'spoferan',
		campaign: `event_${eventStore.event.id}-stay`,
		lat: eventStore.event.lat,
		lng: eventStore.event.lng,
		venue: eventStore.event.full_address,
		markerimage: $image.format(eventStore.event.avatar_thumbnail, {width: 55, height: 55}),
		eventstart: $date(eventStore.event.start_date).unix(),
		eventend: $date(eventStore.event.end_date).unix(),
		maincolor: color,
		gpx: data.gpx_url,
		gpxlinecolor: color,
		gpxlineopacity: 0.7
	};

	return 'https://www.stay22.com/embed/gm?' + Object.keys(params).map(key => `${key}=${params[key]}`).join('&')
});

useMeta({
	title: eventStore.buildPageTitle(t('view.events.stay.index.title', {event: eventStore.event.display_name})),
	description:  t('view.events.stay.index.description', {event: eventStore.event.display_name})
})

</script>

